<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AllSubscribers from "@/view/components/subscribers/AllSubscribers.vue";
import SubscribersList from "@/view/components/subscribers/SubscribersList.vue";
import UploadSubscribersModal from "@/view/components/subscribers/UploadSubscribersModal.vue";

export default {
  name: "subscriber-list",
  components: {
    AllSubscribers,
    SubscribersList,
    UploadSubscribersModal
  },
  methods: {
    clearSubscriberListItem() {
      this.$store.commit("setSubscribersListItem", null);
    }
  },
  data() {
    return {
      tabIndex: 0,
      active_tab: 1
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Subscriber List" }]);
    this.$store.commit("setLocationVisibile", true);
  }
};
</script>

<template>
  <div>
    <v-app>
      <v-main>
        <v-card>
          <v-tabs
            v-model="active_tab"
            background-color="white"
            color="deep-purple accent-4"
            left
          >
            <v-tab @click="tabIndex = 0">All Subscribers</v-tab>
            <v-tab @click="tabIndex = 1">Subscribers List</v-tab>
            <v-tab-item :key="0">
              <v-container fluid>
                <all-subscribers></all-subscribers>
              </v-container>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-container fluid>
                <subscribers-list></subscribers-list>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-main>
    </v-app>
    <!-- Modal -->
    <upload-subscribers-modal></upload-subscribers-modal>
  </div>
</template>

<style scoped>
.tabs /deep/ .tab-pane:focus {
  outline: none;
}

button {
  position: absolute;
  right: 10px;
}
</style>
